import { Component, Event, EventEmitter, Prop, State, h } from '@stencil/core';
import spacetime from 'spacetime';

import { getIncrementClasses, incrementClicked, isIncrementPast } from '../../utils/calendar';
import { customer } from '../../store/customer.store';
import { settings } from '../../store/settings.store';

import { ScheduleAvailableIncrement } from '@artask/tambr-models/models/schedule.model';
import { Space } from '@artask/tambr-models/models/spaces.model';
import { schedule } from '../../store/schedule.store';



@Component({
  tag: 'tambr-calendar-card-view-card',
  styleUrl: 'tambr-calendar-card-view-card.css',
  shadow: true,
})
export class TambrCalendarCardViewCard {

  @Prop() space: Space;
  
  @Event() initCardSlotsRef: EventEmitter<HTMLElement>;

  @Prop() showCardLeftScroll: boolean;
  @Prop() showCardRightScroll: boolean;
  @Prop() scrollCardSlots: (direction: 'left' | 'right') => void;

  @State() showFullDescription: boolean = false;

  slotsElRef: HTMLElement;

  componentDidLoad() {
    this.initCardSlotsRef.emit( this.slotsElRef );
  }


  get upcomingCustomerOrdersExist() {
    const tz = settings.businessSettings.timezone;
    const now = spacetime.now( tz ).add( settings.businessSettings.scheduleSettings.slotDuration, 'minutes' );
    return customer.customerOrders?.some( 
      o => o.space.id === this.space.id && spacetime( o.endTime.toMillis(), tz ).isAfter( now ) 
    );
  }

  get increments() {
    const hidePastSlots = settings.businessSettings?.widgetLayoutSettings?.hidePastSlots;
    const increments = schedule.dateSchedule.increments;
    if ( hidePastSlots?.includes('card') ) {
      return increments?.filter( slot => !isIncrementPast( this.space.id, slot.timestamp ) );
    }
    return increments;
  }

  render() {
    return ([
      this.renderSpaceImages(),

      <tambr-calendar-space-info space={ this.space } type='card' />,

      this.renderCardSlots(),

      this.renderSlotsLegend()
    ]);
  }

  renderSpaceImages() {
    if ( !settings.businessSettings.widgetLayoutSettings?.showSpaceImages?.includes('card') ) return;
    const images = this.space.images?.filter( image => !!image.medium );
    if ( !images?.length ) return;
    return (
      <tambr-space-images type='card' images={ images }></tambr-space-images>
    )
  }


  renderCardSlots() {
    if ( !this.increments?.length ) return;
    
    return (
      <div class={'slots-outer-container' + (this.showCardLeftScroll ? ' left-scroll' : '') + (this.showCardRightScroll ? ' right-scroll' : '' )}>
        { this.leftArrow() }
        <div class='space-card-slots' ref={ ref => { this.slotsElRef = ref } }>
          { this.increments.map( 
            ( increment: ScheduleAvailableIncrement, index: number ) => this.renderCardSlot( this.space, increment, index ) 
          ) }
        </div>
        { this.rightArrow() }
      </div>
    )
  }


  renderCardSlot( space: Space, slot: ScheduleAvailableIncrement, index: number ) {
    return (
      <div class='slot-time-wrapper'>
        <div class={ getIncrementClasses( space.id, slot.timestamp ) } 
          onClick={ () => incrementClicked( space.id, slot.timestamp ) }>
            <tambr-icon class='card-plus' type='plus'></tambr-icon>
        </div>
        { this.renderTimeline( slot, index ) }
      </div>
    )
  }


  renderTimeline( slot: ScheduleAvailableIncrement, index: number ) {
    const increment = settings.businessSettings.scheduleSettings.scheduleIncrement;
    const slotTime = spacetime( slot.timestamp, settings.businessSettings.timezone );
    if ( increment === 15 && slotTime.minute() === 30 ) {
      return <div class='time'>{ slotTime.format('{hour}:{minute}{ampm}') }</div>
    }
    if ( [15, 30].includes(increment) && slotTime.minute() !== 0) return;
    if ( increment === 60 && slotTime.hour() % 2 !== 0 && index) return; 
    return <div class='time'>{ slotTime.format('{hour}{ampm}') }</div>
  }


  renderSlotsLegend() {
    return (
      <div class='slots-legend'>
        <div class='slot-legend'>
          <div class='slot available'></div>
          <div class='legend-text'>Available</div>
        </div>
        <div class='slot-legend'>
          <div class='slot not-available'></div>
          <div class='legend-text'>Reserved</div>
        </div>
        <div class='slot-legend' hidden={!this.upcomingCustomerOrdersExist}>
          <div class='slot current-user-order'></div>
          <div class='legend-text'>Your booking</div>
        </div>
      </div>
    )
  }
  

  leftArrow() {
    return (
      <div class={'tambr-arrow-button left-button ' + (this.showCardLeftScroll ? 'visible' : 'hidden')} onClick={ () => this.scrollCardSlots('left') }>
        <tambr-icon type='left-arrow' class='arrow'></tambr-icon>
      </div>
    );    
  }


  rightArrow() {
    return (
      <div class={'tambr-arrow-button right-button ' + (this.showCardRightScroll ? 'visible' : 'hidden')} onClick={ () => this.scrollCardSlots('right') }>
        <tambr-icon type='right-arrow' class='arrow'></tambr-icon>
      </div>
    );    
  }

}
